<template>
    <div class="topsto">
        <div class="navSto">
            <p class="title">概述</p>
            <div class="border"></div>
            <p class="text">
                StorNet是全球首个基于DAG共识算法的分布式存储网络，其目标是为今后5-10年内构建“数据即生产力、区块链即生产关系”的未来世界提前布局并开展基础工作。其产品主要为自研并部署的SaaS(Storage
                as a Service)平台，对外提供To B的存储服务接口和To C的存储服务应用，并可定制化修改后To
                B进行私有化部署。功能包括创建和执行存储智能合约、存储证明、高效共识、多重签名、提供服务的激励、纠删码（Reed-Solomn编码）。StorNet为B端用户提供高性价比企业级的分布式存储解决方案，为C端用户提供具有持久化数据存储能力、良好隐私保护特性和容错能力的个人数据存储服务。</p>
            <p class="title" style="margin-top:68px ">产品特性</p>
            <div class="border"></div>
            <div class="list">
                <div class="item">
                    <div class="item_img">
                        <img class="tp" src="../../assets/scheme/Image1.png" alt="" style="width: 123px;height: 123px;">
                    </div>
                    <div class="item_text">
                        大幅降低数据存储成本
                    </div>
                </div>
                <div class="item">
                    <div class="item_img">
                        <img class="tp" src="../../assets/scheme/Image2.png" alt=""style="width: 123px;height: 123px;">
                    </div>
                    <div class="item_text">
                        实现可验证的数据持久化存储
                    </div>
                </div>
                <div class="item">
                    <div class="item_img">
                        <img class="tp" src="../../assets/scheme/Image3.png" alt=""style="width: 123px;height: 123px;">
                    </div>
                    <div class="item_text">
                        极高的存储可靠性数据永不丢失
                    </div>
                </div>
                <div class="item">
                    <div class="item_img">
                        <img class="tp" src="../../assets/scheme/Image4.png" alt=""style="width: 123px;height: 123px;">
                    </div>
                    <div class="item_text">
                        实现高安全性高隐私保护的数据存储
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "stornet.vue"
    }
</script>

<style scoped lang="scss">
    .topsto {
        position: relative;

        .navSto {
            margin: 85px 84px 100px;

            .title {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #282F3C;
                margin-left: 9px;
            }

            .border {
                width: 27px;
                height: 3px;
                margin-top: 3px;
                background-color: #056DFF;
            }

            .text {
                width: 826px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #353F52;
                line-height: 30px;
                margin-top: 56px;
            }
            .list {
                display: flex;
                text-align: left;
                margin-top: 76px;
                .item {
                    flex: 0.2;
                    margin-left: 50px;
                    .item_text {
                        color: #6C6E70;
                        font-size: 14px;
                        line-height: 23px;
                        width: 120px;
                        text-align: center;
                        margin-top:34px ;
                    }
                }
            }
        }
    }

</style>
